"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _modalLoader = require("@wsb/modal-loader");
var _useIdempotentImpression = require("../helpers/useIdempotentImpression");
var _eventMap = require("../helpers/eventMap");
var LoadWithImpression = function LoadWithImpression() {
  (0, _useIdempotentImpression.useIdempotentImpression)(_eventMap.EventKey.LOADER_LOADING_MODAL_IMPRESSION);
  return _modalLoader.DefaultLoader;
};
var _default = exports["default"] = LoadWithImpression;